module.exports = __webpack_public_path__ + "img/cns_printer_mac19.399d60cd.png";